import { Close } from '@atom-learning/icons'
import * as React from 'react'

import { styled } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Badge } from '../badge/Badge'
import { Icon } from '../icon/Icon'
import { Text } from '../text/Text'
import { BulkActionsSelectedRowActions } from './DataTableBulkActionsSelectedRowActions'
import { useDataTable } from './DataTableContext'

const StyledContainer = styled('div', {
  base: [
    'flex',
    'pl-3',
    'pr-1',
    'py-2',
    'mb-4',
    'mt-2',
    'justify-between',
    'items-center',
    'rounded-lg',
    'bg-primary-800',
    'pointer-events-auto',
    'z-2',
    'w-full',
    'mx-4',
    'shadow-lg',
    'sm:max-w-200',
    'lg:max-w-250',
    'lg:mb-8',
    'lg:pl-4',
    'lg:pr-1',
    'lg:py-3',
    'xl:max-w-350',
    'xl:mb-8',
    'xl:pl-6',
    'xl:pr-2',
    'xl:py-4'
  ]
})

export const DataTableBulkActionsFloating = Object.assign(
  ({
    children,
    ...rest
  }: React.PropsWithChildren<React.ComponentProps<typeof StyledContainer>>) => {
    const { rowSelection, toggleAllPageRowsSelected } = useDataTable()

    const actionBarRef = React.useRef<HTMLDivElement>(null)

    const numberOfSelectedRows = React.useMemo(() => {
      return Object.keys(rowSelection || {}).length
    }, [rowSelection])

    const handleDeselectAllPageRows = () => toggleAllPageRowsSelected(false)

    if (numberOfSelectedRows === 0) return null

    return (
      <section
        ref={actionBarRef}
        className="pointer-events-none sticky bottom-0 left-0 flex justify-center"
      >
        <StyledContainer {...rest}>
          <div className="flex flex-auto items-center justify-start gap-2">
            <Badge
              theme="success"
              size="xs"
              emphasis="subtle"
              className="h-6 min-w-6"
            >
              {numberOfSelectedRows}
            </Badge>
            <Text size="sm" weight="bold" className="text-white">
              selected
            </Text>
          </div>
          <div className="flex flex-auto items-center justify-end gap-3">
            {children}
            <ActionIcon
              appearance="simple"
              theme="white"
              size="md"
              onClick={handleDeselectAllPageRows}
              label="close"
            >
              <Icon is={Close} />
            </ActionIcon>
          </div>
        </StyledContainer>
      </section>
    )
  },
  {
    SelectedRowActions: BulkActionsSelectedRowActions
  }
)
